/* global Skills */

window.Skills || (window.Skills = {})
Skills.components = {}
Skills.initSkillsTooltip = function (element) {
  const tooltip = window.createTooltips(element[0].querySelector('.skill-name span'))[0]
  tooltip?.update()
}

Skills.initHelpPopover = function ($selector, additionalClass) {
  if (additionalClass == null) additionalClass = ''
  const helpLink = $("<a class='link-dashed-span small'><i class='ti-help-alt mright5'></i><span>" + (I18n.t('layouts.support.show_hint')) + '</span></a>')
  helpLink.on('click', function () {
    const popover = window.createPopovers($selector)[0]
    popover?.hide()
    $('#skills_help').modal('show')
  })
  // $selector.on('mouseenter', function(e, b) {
  //   $('.popover').hide();
  // });
  return $selector.each(function () {
    if ($(this).find('.star').length === 4 || $(this).find('.switchery').length) {
      return window.createPopovers(this, {
        template: `<div class="popover ${additionalClass}" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>`,
        html: true,
        content: function () {
          return helpLink
        },
        title: '',
        trigger: 'hover',
        delay: 1000,
        placement: 'left',
        container: 'body'
      })
    }
  })
}

Skills.additionalSkillsInit = function (target) {
  $('#add-additional-skill').on('click', function (e) {
    e.preventDefault()
    const data = $('.additional_skills #skills').select2('data')
    if (data) {
      if ($('#selected_' + data.id, '#' + target).length) {
        const element = $('#selected_' + data.id)
        element.parents('.line').find('.skill-name span', '#' + target).css({
          background: 'yellow',
          padding: '0 5px'
        })
        $('html, body').animate({
          scrollTop: element.closest('div').offset().top - 60
        }, 1000)
      } else {
        const component = {
          skill_id: data.id,
          mandatory: null,
          name: data.text,
          input_type: data.input_type,
          hr_stars: 0
        }
        if (Skills.components[target]) {
          const tree = Skills.components[target].getTree()
          tree.unshift(component)
          Skills.components[target].setTree(tree)
        }
        $('.additional_skills #skills').select2('val', '')
      }
    }
  })
  $('.additional_skills #skills').on('change', function () {
    $('.skills-tree .skill-name span').removeAttr('style')
  })
}
